import { ENVS, ENV_ORDER, type EnvName } from "../config/envs";
import { useEnv, useSetEnv } from "../env/EnvProvider";

const DOT_COLOR: Record<EnvName, string> = {
  local: "bg-slate-400",
  dev: "bg-teal-400",
  staging: "bg-amber-400",
  prod: "bg-red-500",
};

export function EnvSwitcher() {
  const env = useEnv();
  const setEnv = useSetEnv();

  return (
    <div className="flex items-center gap-2">
      <span
        aria-hidden
        className={`inline-block h-2 w-2 rounded-full ${DOT_COLOR[env.name]}`}
      />
      <select
        aria-label="Switch environment"
        value={env.name}
        onChange={(e) => setEnv(e.target.value as EnvName)}
        className="rounded border border-bg-card-elevated bg-bg-card px-2 py-1 text-sm text-text-light focus:outline-none focus:ring-1 focus:ring-accent"
      >
        {ENV_ORDER.map((n) => (
          <option key={n} value={n}>
            {ENVS[n].label}
          </option>
        ))}
      </select>
      <span className="hidden truncate text-xs text-text-muted sm:inline">
        {env.apiBaseUrl}
      </span>
    </div>
  );
}
